/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_PantsInputs */

const en_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pants`)
};

const es_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalones`)
};

const fr_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantalons`)
};

const de_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hosen`)
};

const ja_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`パンツ`)
};

const zh_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长裤`)
};

const ar_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بناطيل`)
};

const id_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Celana Panjang`)
};

const it_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pantaloni`)
};

const ru_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Штаны/Брюки`)
};

const pt_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calças`)
};

const ko_val_pants = /** @type {(inputs: Val_PantsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`바지`)
};

/**
* | output |
* | --- |
* | "Pants" |
*
* @param {Val_PantsInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_pants = /** @type {((inputs?: Val_PantsInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_PantsInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_pants(inputs)
	if (locale === "es") return es_val_pants(inputs)
	if (locale === "fr") return fr_val_pants(inputs)
	if (locale === "de") return de_val_pants(inputs)
	if (locale === "ja") return ja_val_pants(inputs)
	if (locale === "zh") return zh_val_pants(inputs)
	if (locale === "ar") return ar_val_pants(inputs)
	if (locale === "id") return id_val_pants(inputs)
	if (locale === "it") return it_val_pants(inputs)
	if (locale === "ru") return ru_val_pants(inputs)
	if (locale === "pt") return pt_val_pants(inputs)
	return ko_val_pants(inputs)
});